export interface CardLimits {
  id: string | number;
  examTaskGroupName: string;
  examTaskGroupId: string | number;
  examinerPermissionId: string | number;
  limitDaily: number;
  limitDesk: number;
  limitTotal: number;
  extendedAccessDuration: number | null;
  validSince: Date | string;
  calculateCardLimitResult?: number;
}

export interface ExaminingTeamMembers {
  id: string | number;
  examTaskGroupId: string | number;
  examinerId: string;
  fullName: string;
  examinerPermissionId: string;
  limitDaily: number;
  limitDesk: number;
  limitTotal: number;
  extendedAccessDuration: number;
  validSince: Date | string;
}

export interface IndividualBlockingLimits {
  examinerPermissionId: string;
  examinerNumber: string;
  firstName: string;
  lastName: string;
  blockingLimitId: string;
  totalLimitOutOfTolerance: number | null;
  sequentialLimitOutOfTolerance: number | null;
  totalLimitWithinTolerance: number | null;
  sequentialLimitWithinTolerance: number | null;
}

export enum UpdateCardLimitsResponse {
  CardLimitsNotValid,
  ExamTaskGroupOrExaminerPermissionNotExists,
  CardLimitAndExtendedAccessDurationIsSameAsPreviousOne,
  Success,
}
